__turbopack_context__.v({
  "button__iw7VZ": "PlasmicHomeSolutionsSectionCard-module___NR-oq__button__iw7VZ",
  "cardContent": "PlasmicHomeSolutionsSectionCard-module___NR-oq__cardContent",
  "freeBox__uyYfI": "PlasmicHomeSolutionsSectionCard-module___NR-oq__freeBox__uyYfI",
  "freeBox__zirLo": "PlasmicHomeSolutionsSectionCard-module___NR-oq__freeBox__zirLo",
  "h4__yQaql": "PlasmicHomeSolutionsSectionCard-module___NR-oq__h4__yQaql",
  "p__cnPtZ": "PlasmicHomeSolutionsSectionCard-module___NR-oq__p__cnPtZ",
  "svg__aYj3G": "PlasmicHomeSolutionsSectionCard-module___NR-oq__svg__aYj3G",
  "svg__kCxQ6": "PlasmicHomeSolutionsSectionCard-module___NR-oq__svg__kCxQ6",
  "svg__sQoS": "PlasmicHomeSolutionsSectionCard-module___NR-oq__svg__sQoS",
});
